<div [formGroup]="form" class="w-100">
  <!-- <label [attr.for]="field.key">{{field.title}}</label> -->

  <div [ngSwitch]="field.fieldType">
  <!-- =================== TEXT FILED ===============   -->
    <div class="form-group" *ngSwitchCase="'TEXT'" >
      <input *ngIf= "field.key !== 'MULTILINE_TEX'" class="form-control" [formControlName]="field.key"
             [placeholder]="field.placeHolder"
             [id]="field.key" [type]="field.fieldType"
             [maxlength] = "field.maxLength? field.maxLength : ''"
             [minlength] = "field.minLength? field.minLength : ''"
             [required] = "!field.optional"
             [readonly]="!field.editable">
             <textarea *ngIf= "field.key === 'MULTILINE_TEX'" 
             class="form-control" 
             [formControlName]="field.key"
             [placeholder]="field.placeHolder"
             [id]="field.key"
             [readonly]="!field.editable"
             cols="30" rows="10"
             [required] = "!field.optional"></textarea>
             <span *ngIf = "showLable" class="floating-label">{{field.title}}</span>
             <span *ngIf="getError" class="errorInput">{{field.title}} نا معتبر است</span>
             <span *ngIf= "field.key === 'IBAN'" class="saved-icon">IR</span>

    </div>
    <!-- =================== SINGLE SELECT ===============   -->
    <div class="form-group" *ngSwitchCase="'DROP_DOWN'" >
      <select value = "" class="select-form-control" [class.focused]="field.value" [formControlName]="field.key">
        <option *ngFor="let opt of field.items; let i = index" [ngValue]="opt">{{opt}}</option>
      </select>
      <span class="floating-label">یکی انتخاب کن</span>
    </div>
    <!-- =================== MULTI SELECT ===============   -->
    <div class="form-group" *ngSwitchCase="'MULTI_SELECTOR'">
      <h2 class="header2">{{field.title}}</h2>
      <ul class="multiple">
        <li *ngFor="let opt of field.items; let i = index">
          <div class="checkbox">
            <input type="checkbox" [id]="i" [checked]="field?.value !== null && field?.value.includes(opt)" (change) ="getCheckBoxes($event, opt)">
            <label [for]="i"><span>{{opt}}</span></label>
         </div>
        </li>
      </ul>
      <span *ngIf="isClicked && checkedList.length === 1" class="errorInput">حداقل موارد انتخابی باید دو مورد باشد.</span> 
      <span *ngIf="isClicked && checkedList.length >= 5" class="errorInput">حداثر موارد انتخابی باید چهار مورد باشد.</span> 
      <!-- <select class="form-control w-100" multiple [id]="field.key"  [formControlName]="field.key">
        <option *ngFor="let opt of field.items; let i = index" [value]="opt">{{opt}}</option>
      </select> -->
    </div>
    <!-- =================== DATE PICKER ===============   -->
    <div class="form-group" *ngSwitchCase="'DATE_PICKER'">
      <app-date-picker-shamsi [hasErr]="dateErr" (skyWlak)="getDate($event, field.key)" [myDate]="field.value" [config] = "datePickerConfig" ></app-date-picker-shamsi>
    </div>
    <!-- =================== RADIO BUTTONS ===============   -->
    <div class="d-flex flex-column" *ngSwitchCase="'SINGLE_SELECTOR'">
      <h2 class="header2">{{field.title}}</h2>
      <div class="d-flex flex-row justify-content-between flex-wrap">
        <!-- <div style="width: 50%;" class="form-group" *ngFor="let radioItem of field.items; let i =  index">
          <label [for]="radioItem">{{radioItem}}</label>
          <input [name]="randomName" [id]="radioItem" type="radio" [value]="radioItem" [formControlName]="field.key">
        </div> -->
        <div style="width: 50%;" class="form-group" *ngFor="let radioItem of field.items; let i =  index">
          <input type="radio" [value]="radioItem" [formControlName]="field.key">
          <span>{{radioItem}}</span>
        </div>

      </div>
    </div>
  </div>
  <!-- =================== HELP BLOCKS===============   -->
  <!-- <div class="errorMessage" *ngIf="!isValid">{{field.title}} نا معتبر است </div> -->
  <!-- <span *ngIf="getError" class="errorInput">{{field.title}} نا معتبر است</span> -->
</div>
